import SettingsRoot from './Settings';

const SettingsAccount = () => import( /* webpackChunkName: "settings" */ './SettingsAccount');
const SettingsUsers = () => import( /* webpackChunkName: "settings" */ './SettingsUsers');
const SettingsTracking = () => import( /* webpackChunkName: "settings" */ './SettingsTracking');
const SettingsPayment = () => import( /* webpackChunkName: "settings" */ './SettingsPayment');
const SettingsPaymentPayoneerPay = () => import( /* webpackChunkName: "settings" */ './SettingsPayment/SettingsPaymentPayoneerPay');
const SettingsEmails = () => import( /* webpackChunkName: "settings" */ './SettingsEmails');
const SettingsSecurity = () => import( /* webpackChunkName: "settings" */ './SettingsSecurity');

import payoutRoutes from './SettingsPayouts/_routes';

export default {
  path: '/settings',
  name: 'settings',
  redirect: '/settings/account',
  component: SettingsRoot,
  children: [{
      path: 'account',
      name: 'settingsAccount',
      component: SettingsAccount,
    }, {
      path: 'users',
      name: 'settingsUsers',
      component: SettingsUsers,
    }, {
      path: 'emails',
      name: 'settingsEmails',
      component: SettingsEmails
    }, {
      path: 'tracking',
      name: 'settingsTracking',
      component: SettingsTracking
    }, {
      path: 'payment',
      name: 'settingsPayment',
      component: SettingsPayment,
    }, {
      path: 'pay',
      name: 'settingsPay',
      component: SettingsPaymentPayoneerPay,
    }, {
      path: 'security',
      name: 'settingsSecurity',
      component: SettingsSecurity,
    },
    payoutRoutes,
  ],
};